import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        // Sessione scaduta: dopo il nuovo login si torna alla pagina in cui si era
        const da = window.location.pathname + window.location.search;
        window.location.href = da === '/' ? '/login' : `/login?da=${encodeURIComponent(da)}`;
      }
    } else if (err.response?.data?.codice === 'SEZIONE_NON_CONSENTITA' && err.config?.method === 'get'
      && window.location.pathname !== '/accesso-negato') {
      // Lettura negata: pagina dedicata. Una scrittura negata resta un errore nel modulo.
      window.location.href = '/accesso-negato';
    } else if (err.response?.data?.codice === 'CAMBIO_PASSWORD_RICHIESTO' && window.location.pathname !== '/cambia-password') {
      window.location.href = '/cambia-password';
    }
    // Deadlock o timeout del database (409/503 con codice RIPROVA): avviso comune "riprova", senza finestra di conflitto e senza perdere i dati inseriti
    if (err.response?.data?.codice === 'RIPROVA') {
      window.dispatchEvent(new CustomEvent('hub-riprova', { detail: err.response.data.errore }));
    }
    return Promise.reject(err);
  }
);

export default api;
